export const careerTypes = {
    CAREER_ACTION_START: "CAREER_ACTION_START",
    CAREER_GET_SUCCESS: "CAREER_GET_SUCCESS",
    CAREER_GET_FAILED: "CAREER_GET_FAILED",
    CAREER_ACTION_END: "CAREER_ACTION_END",
}
